import { isString } from 'lodash';
import { toast } from 'react-toastify';

import Body from './components/Body';
import { ToastProps } from './types';

const getData = (props: ToastProps | string): ToastProps => {
  if (isString(props)) {
    return {
      body: props,
    };
  }

  return props;
};

const toastMessage = {
  error: (props: ToastProps | string) => {
    toast.error((props) => <Body {...props} />, {
      data: getData(props),
    });
  },
  info: (props: ToastProps | string) => {
    toast.info((props) => <Body {...props} />, {
      data: getData(props),
    });
  },
  success: (props: ToastProps | string) => {
    toast.success((props) => <Body {...props} />, {
      data: getData(props),
    });
  },
  warning: (props: ToastProps | string) => {
    toast.warning((props) => <Body {...props} />, {
      data: getData(props),
    });
  },
};

export default toastMessage;
